export default __webpack_public_path__ + "static/media/137.5dce37e9.png";